module.exports = "/img/partnership-1.bee0a1cc.png";